// frontend/src/context/AcademicYearContext.js
import React, { createContext, useState, useContext, useEffect } from 'react';
import { getAllAcademicYears, setCurrentAcademicYear } from '../services/academicYearService';
import { message } from 'antd';
import { useAuth } from './AuthContext';

const AcademicYearContext = createContext(null);

export const AcademicYearProvider = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const [currentYear, setCurrentYear] = useState(null);
    const [allYears, setAllYears] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchYears = async () => {
        if (!isAuthenticated) return;
        setLoading(true);
        try {
            const years = await getAllAcademicYears();
            setAllYears(years);
            const current = years.find(y => y.is_current);
            if (current) {
                setCurrentYear(current);
            } else {
                // Critical error: No current year is set
                message.error('CRITICAL: No current academic year is set. Data may be unavailable.');
            }
        } catch (error) {
            message.error('Failed to fetch academic year data.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchYears();
        } else {
            // If not authenticated, set a default state so the loading indicator goes away
            setCurrentYear(null);
            setAllYears([]);
            setLoading(false);
        }
    }, [isAuthenticated]);

    const changeCurrentYear = async (yearId) => {
        try {
            const response = await setCurrentAcademicYear(yearId);
            message.success(response.message);
            fetchYears(); // Re-fetch data to update all components
        } catch (error) {
            message.error('Failed to change current academic year.');
        }
    };

    return (
        <AcademicYearContext.Provider value={{ currentYear, allYears, changeCurrentYear, loading }}>
            {children}
        </AcademicYearContext.Provider>
    );
};

export const useAcademicYear = () => useContext(AcademicYearContext);